import React from 'react'
import Modal from 'react-bootstrap/lib/Modal';

const MIN_HOLDER_NAME_LENGTH = 5;

/*function isAmex(cardNumber) {
    const reg = new RegExp('^3[47]');
    return reg.test(cardNumber);
} */

function isAmex(card) {
    return (card && card.brand === 'American Express');
}

export default class AddStripeCreditCardModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            inputDisabled: true,
            holderName: ""
        };
    }

    handleSubmit = (event) => {
        // Prevent the form from being submitted:
        event.preventDefault();

        if (this.state.inputDisabled === true) { return }

        const { onNewCreditCardError, onNewCreditCard} = this.props;

        this.setState({loading: true});

        this.stripe
          .createPaymentMethod({type: 'card',
              card: this.cardNumberElement,
              billing_details: { name: this.state.holderName}})
          .then((result) => {
              this.setState({loading: false});

              if (result.error) {
                  onNewCreditCardError(I18n.t("cart_summary.credit_cards.cannot_use_this_card"));
              } else {
                const {paymentMethod} = result;

                const {card} = paymentMethod;

                  if (isAmex(card) === true) {
                      onNewCreditCardError(I18n.t("cart_summary.credit_cards.cannot_use_amex_card"));
                      return;
                  }

                  onNewCreditCard(paymentMethod);
              }
          })
          .catch((error) => {
              this.setState({loading: false});
              onNewCreditCardError(I18n.t("cart_summary.credit_cards.cannot_use_this_card"));
          });

        /*this.stripe.createToken(this.cardNumberElement).then((result) => {

            this.setState({loading: false});

            if (result.error) {
                this.props.onNewCreditCardError(I18n.t("cart_summary.credit_cards.cannot_use_this_card"));
            } else {
                const {token} = result;

                if (isAmex(token.card) === true) {
                    this.props.onNewCreditCardError(I18n.t("cart_summary.credit_cards.cannot_use_amex_card"));
                    return;
                }

                this.props.onNewCreditCard(result.token);
            }
        }).catch((err) => {
            console.error(err);
        });*/
    };

    componentDidUpdate(prevProps, prevState) {
        if ((this.props.show === true) && (prevProps.show === false)) {

            //TODO: Remove the timeout!
            setTimeout(this.setupStripeElements, 500);
        }
    }

    setupStripeElements = () => {
        const style = {
            'style': {
                'base': {
                    fontSize: '16px',
                },
                'empty': {
                    '::placeholder': {
                        color: '#ccc',
                    },
                }
            }
        };

        this.stripe = Stripe(this.props.stripe_key);
        this.elements = this.stripe.elements();

        this.cardNumberElement = this.elements.create('cardNumber', style);
        this.cardNumberElement.mount('#cardNumber');

        this.elements.create('cardExpiry', style).mount('#cardExpiry');
        this.elements.create('cardCvc', style).mount('#cardCvc');
    }

    handleHolderNameChange = (event) => {
        const name = event.target.value || '';

        this.setState({ holderName: event.target.value, inputDisabled: name.length < MIN_HOLDER_NAME_LENGTH});
    }

    render() {
        return (
            <Modal show={this.props.show} onHide={this.props.onHide} className="modal modal--full-height cart-summary-modal" animation={true}>
                <Modal.Header closeButton>
                    <Modal.Title>{I18n.t("cart_summary.credit_cards.add_new_credit_card_title")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form id="payment-form">
                        <span className="payment-errors"/>

                        <div className="row">
                            <div className="col-sm-12">
                                <div className="form-group has-feedback">
                                    <label
                                      htmlFor="holder_name">{I18n.t("cart_summary.credit_cards.form.holder_name")}</label>
                                    <input className="stripe-input" name="holder_name" type="text" value={this.state.holder_name} onChange={ this.handleHolderNameChange}/>
                                </div>
                            </div>
                            <div className="col-sm-12">
                                <div className="form-group has-feedback">
                                    <label
                                      htmlFor="cardnumber">{I18n.t("cart_summary.credit_cards.form.number")}</label>
                                    <div className="stripe-input" id="cardNumber"/>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-xs-12 col-sm-6">
                                <div className="form-group has-feedback">
                                    <label
                                        htmlFor="exp-date">{I18n.t("cart_summary.credit_cards.form.expiration")}</label>
                                    <div className="stripe-input" id="cardExpiry"/>
                                </div>
                            </div>
                            <div className="col-xs-12 col-sm-6">
                                <div className="form-group has-feedback">
                                    <label htmlFor="cvc">{I18n.t("cart_summary.credit_cards.form.cvc")}</label>
                                    <div className="stripe-input" id="cardCvc"/>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12">
                                <p className="small-text">{I18n.t("cart_summary.credit_cards.supported_card_types")}</p>
                                <p className="small-text">{I18n.t("cart_summary.credit_cards.secure_payment_notice")}</p>
                            </div>
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <div className="row">
                        <div className="col-sm-12 col-md-8 col-md-push-2">
                            <p>
                                <a className="cc-submit btn btn-primary btn-block"
                                   onClick={this.handleSubmit}
                                   disabled={this.state.loading || this.state.inputDisabled}
                                   href="">
                                    {I18n.t("cart_summary.credit_cards.add_new_credit_card_button")}
                                </a>
                            </p>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        );
    }
}
